import { createTheme } from "@mui/material/styles";



const theme = createTheme({
  spacing: 4, // smaller global spacing

 palette: {
    mode: "light",
    primary: { main: "#1976d2" },
    secondary: { main: "#dc004e" },
  },

  components: {
    MuiButton: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          padding: "4px 10px",
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          fontWeight: 500,
          color: "#666",
          top: "-4px",
        },
        shrink: {
          fontSize: "12px",
          color: "#444",
        },
      },
    },
  

    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },

    MuiList: {
      defaultProps: {
        dense: true,
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "6px 10px",
        },
      },
    },
  },
});

export default theme;